// -- [Role-based headlines and subtitles - parsed from MD; management = Dealer Principal, sales = Sales]

import type { RoleKey } from '@/types/content'

export interface RoleHeadlineItem {
  headline: string
  subtitle: string
}

const MANAGEMENT_HEADLINES: RoleHeadlineItem[] = [
  {
    "headline": "Save AUD$80K a year without cutting staff",
    "subtitle": "Turn your filing room, storage containers, and paper chaos into one AI empowered, searchable archive that frees a whole employee’s worth of time."
  },
  {
    "headline": "Your filing room is costing you a full salary",
    "subtitle": "Replace AUD$91K of paper storage and admin with Drivible and redeploy that money into sales, service, or another Xmas bonus."
  },
  {
    "headline": "One scanner, one email address, one salary saved",
    "subtitle": "Stack today’s ROs, deal packs or invoices, hit scan, and let Drivible split and index everything so your team never sorts and files by hand again."
  },
  {
    "headline": "Scan it. Search it. Shred it. Save AUD$80K.",
    "subtitle": "Go from 10 minute cabinet hunts to one‑second Google‑style search for any RO, deal, or invoice in your dealership."
  },
  {
    "headline": "Your filing cabinet called. It wants to retire.",
    "subtitle": "Give it what it wants and keep your seven years of paper in the cloud, with instant search and 7 year retention built in."
  },
  {
    "headline": "Turn a back room of boxes into AUD$80K a year",
    "subtitle": "Free rooms of storage space and possibly over 2,000 hours of staff time by digitising your documents once and finding them forever."
  },
  {
    "headline": "Hire a salesperson, not a filing clerk",
    "subtitle": "Drivible saves the equivalent of one full time admin chasing paper so you can invest headcount where it actually grows revenue."
  },
  {
    "headline": "Audit ready in seconds, not scrambling for days",
    "subtitle": "When OEMs or auditors call, pull up every RO, deal pack, and invoice instantly instead of turning the office upside down."
  },
  {
    "headline": "Make your next OEM audit boring",
    "subtitle": "Centralise every document, track every change, and find what auditors want in seconds."
  },
  {
    "headline": "2,054 hours a year back in your business",
    "subtitle": "That’s how much filing and retrieval time one large dealership reclaimed by moving to Drivible’s AI empowered document storage."
  },
  {
    "headline": "When Paper storage and labour costs you AUD$92K and Drivible costs you AUD$6.2K the maths is simple",
    "subtitle": "Swap manual filing into archive boxes for a cloud platform that gives every department instant access to what they need."
  },
  {
    "headline": "Find any RO in 2 seconds, not 30 minutes",
    "subtitle": "Search by RO number, rego, VIN, customer or whatever you can remember and watch your team stop wasting time walking to the filing room."
  },
  {
    "headline": "No more shipping containers full of paperwork",
    "subtitle": "Scan, search, and shred with 7‑year retention and audit logs so you can sleep at night knowing nothing’s been lost."
  },
  {
    "headline": "Built by dealers, not generic software people",
    "subtitle": "Drivible understands ROs, deal packs, finance apps, and audits because it was designed around real Australian dealerships."
  },
  {
    "headline": "One platform, every document, every department",
    "subtitle": "Sales, Service, Parts, and Accounts all save to the same cloud archive, so no one has to ask, “Where did you file that?” again."
  },
  {
    "headline": "Your warehouse of paper has a price tag",
    "subtitle": "When you see the real cost of storage, wages, and supplies you'll realise just how quickly Drivible pays for itself."
  },
  {
    "headline": "Stop paying AUD$80K to people who lose the paperwork",
    "subtitle": "Replace fragile, staff dependent filing systems with instant, auditable search that doesn’t walk out the door when someone resigns."
  },
  {
    "headline": "Compliance should be automatic, not a second job",
    "subtitle": "Lock in 7‑year cloud retention, audit logs, and version history so passing audits becomes a byproduct of your daily workflow."
  },
  {
    "headline": "From stacks of ROs to searchable in minutes",
    "subtitle": "Bulk scan today’s jobs, let AI separate and label them, and give your Service Manager their evenings back."
  },
  {
    "headline": "Turn document chaos into a quiet profit lever",
    "subtitle": "Cut 87% of your document management costs and turn admin savings into the next technician, brand, or branch you’ve been planning."
  },
  {
    "headline": "Paper, people, profit - You can pick two",
    "subtitle": "Cut paper, free people, and keep the profit by moving filing costs into a our digital document storage system that never forgets a file."
  },
  {
    "headline": "Filing, floorspace, full time freed",
    "subtitle": "Replace cabinets and boxes of storage with cloud search that could give you back one whole employee’s worth of time every year."
  },
  {
    "headline": "Scan, sort, save",
    "subtitle": "Bulk‑scan today’s ROs and deals, let AI do the data entry and sorting, and watch thousands of hours of labor fall off your expense line."
  },
  {
    "headline": "Boxes, binders and backroom be gone",
    "subtitle": "Ditch archive boxes and warehouse shelving, keep the required 7‑year retention, but reclaim the AUD$80K+ you’re likely burning on paper storage."
  },
  {
    "headline": "Paper, people, peace of mind",
    "subtitle": "Move from fragile, staff dependent filing systems to a cloud archive that survives resignations, audits, and anything else the year throws at you."
  },
  {
    "headline": "Scan, search, satisfy the auditors",
    "subtitle": "When OEMs call, answer in seconds, with complete histories instead of sending staff on 30 minute treasure hunts."
  },
  {
    "headline": "Filing, finding, five‑second fixes",
    "subtitle": "Swap 10–30 minute cabinet hunts for five‑second searches by RO, Invoice number, rego, VIN, or customer name."
  },
  {
    "headline": "From paper pain to profit per person",
    "subtitle": "Turn thousands of hours of filing and retrieval into productive work that actually moves the needle on CSI and net profit."
  },
  {
    "headline": "Cabinets, clips, and costly chaos",
    "subtitle": "Staples, sleeves, and storage rooms are eating your wages, let AI and bulk scanning handle documents while your team handles customers."
  },
  {
    "headline": "Remove Paper piles and gain profits",
    "subtitle": "Every box of paperwork you scan into Drivible is one less minute filing, one less metre of storage, and one step closer to saving an employee worth of time a year."
  },
  {
    "headline": "Filing fatigue to frictionless files",
    "subtitle": "Give your team one simple habit - Scan and Email. Now let Drivible handle the rest, from separation to search."
  },
  {
    "headline": "Chaos, cabinets, costly compliance",
    "subtitle": "Stop paying for messy rooms and manual audits. Switch to structured, searchable, cloud based storage built for dealers."
  },
  {
    "headline": "Staff, storage, and silent savings",
    "subtitle": "Without changing your DMS or scanners, quietly strip out up to AUD$80K a year in wasted document labour and storage overhead."
  },
  {
    "headline": "From dusty documents to digital dollars",
    "subtitle": "Convert seven years of dusty archives into a digital asset that saves wages, floorspace, and your team’s sanity."
  },
  {
    "headline": "Paper scanning, people power, profit",
    "subtitle": "Let software handle the boring bits so your people can focus on customers, CSI, and the KPIs you’re actually measured on."
  },
  {
    "headline": "Scan stacks, shred storage, save salaries",
    "subtitle": "Scan a day’s work in one go, shred the paper once it’s in the cloud, and stop paying a full time wage to babysit boxes."
  },
  {
    "headline": "Your filing room is your quietest employee",
    "subtitle": "It likely costs you AUD$80K a year and never sells a single car. Give it a gold watch, retire it and let Drivible do the paperwork instead."
  },
  {
    "headline": "The most expensive room no customer ever sees",
    "subtitle": "Turn your backroom of boxes into an extra salary, extra bay, or extra brand, instead of a shrine to old, coffee stained paperwork."
  },
  {
    "headline": "Imagine hiring a gun salesperson… and putting them in the filing room",
    "subtitle": "That’s what you’re doing with AUD$80K of wages. Free that time and let Drivible handle the cabinets."
  },
  {
    "headline": "Make your next OEM audit… boring",
    "subtitle": "No war rooms, no pizza bribes, no late nights. Just every document, on screen, in seconds."
  },
  {
    "headline": "Your filing cabinet has had a good innings",
    "subtitle": "It’s time to retire it gracefully and let AI and cloud storage open for the next season."
  },
  {
    "headline": "What would you do with an extra AUD$80K every year?",
    "subtitle": "Add a tech? Upgrade the showroom? Or do you prefer to keep feeding the paper monster out the back?"
  },
  {
    "headline": "Be the Dealer Principal who never loses a document",
    "subtitle": "When the auditor, OEM, or accountant asks, you can be the one who always has the answer on screen in seconds."
  },
  {
    "headline": "Turn “Who’s got that file?” into “It’s in Drivible.”",
    "subtitle": "One place, one search bar, and no more shouting across the office for missing deal packs, ROs or invoices."
  },
  {
    "headline": "Give your team their Friday afternoons back",
    "subtitle": "Stop wasting the last hours of every day filing and hunting in cabinets, scan once, search forever."
  },
  {
    "headline": "Your paper piles are a tax on your time",
    "subtitle": "Some dealers find 2,054 hours a year disappear into filing and retrieval. That's time you could spend fixing margin, CSI, or just leaving on time."
  },
  {
    "headline": "From “don’t touch that box” to “just check Drivible”",
    "subtitle": "Lose the one‑person‑knows‑everything system and make every RO, invoice, and deal pack findable by anyone who needs it."
  },
  {
    "headline": "Be the dealer who sleeps through audit season",
    "subtitle": "Cloud retention, audit logs, and instant search mean no more lying awake wondering what’s missing in the filing room."
  },
  {
    "headline": "Turn cardboard into career capital",
    "subtitle": "Swapping boxes and binders for Drivible frees cash and time you can invest in people, training, and growth."
  },
  {
    "headline": "Let software do the boring bits",
    "subtitle": "Filing, splitting PDFs, and hunting for ROs are jobs for AI now, not for your most patient admin."
  },
  {
    "headline": "Your next innovation doesn’t need a robot",
    "subtitle": "It might just be finally stopping staff from walking to a filing cabinet 20 times a day."
  },
  {
    "headline": "Be remembered as the DP who killed the paper room",
    "subtitle": "Not the one who left another shipping container full of boxes for the next generation to deal with."
  },
  {
    "headline": "The cheapest productivity hack in your dealership",
    "subtitle": "Swap paper and filing for cloud storage and watch your team quietly get hours back every week."
  },
  {
    "headline": "Be remembered as the DP who killed the paper room",
    "subtitle": "Not the one who left yet another shipping container full of boxes for the next generation to deal with."
  },
  {
    "headline": "Turn admin from anchor to advantage",
    "subtitle": "When documents are instant, audits are easy and your team spends time with customers instead of cabinets."
  },
  {
    "headline": "Future proof your dealership, one scan at a time",
    "subtitle": "Start with today’s ROs and deal packs and watch the next seven years of risk, rent, and wasted wages shrink into a search bar."
  }
];

const SALES_HEADLINES: RoleHeadlineItem[] = [
  {
    "headline": "Deal packs done in 10 seconds",
    "subtitle": "Turn 30 minute paper hunts into instant, searchable deal files your sales team can actually trust."
  },
  {
    "headline": "More test drives, less admin",
    "subtitle": "Let Business Managers control finance and test drives without stealing your salespeople’s phones or time."
  },
  {
    "headline": "Hit your targets without drowning in paperwork",
    "subtitle": "Keep every Deal, Invoice and Delivery pack audit‑ready so your team can focus on selling, not chasing signatures."
  },
  {
    "headline": "Contracts signed while the customer’s still excited",
    "subtitle": "Send eSign links by SMS and email so deals are signed fast. Works in store or at home."
  },
  {
    "headline": "Get the Deposits in before the customer cools",
    "subtitle": "Request card payments and signing Terms and Conditions in one branded flow, with instant confirmations for sales."
  },
  {
    "headline": "Every deal pack, one search bar away",
    "subtitle": "Find any contract, client or VIN in seconds with AI empowered document search across your whole dealership."
  },
  {
    "headline": "Your next OEM audit could be boring",
    "subtitle": "Find your sales files in moments instead of losing nights to prep and photocopying."
  },
  {
    "headline": "Stop losing sales to missing signatures",
    "subtitle": "Build bulletproof digital deal files where every approval, term and condition is captured and versioned automatically."
  },
  {
    "headline": "Scan once, sell more",
    "subtitle": "Bulk scan today’s deals and let our systems split, label and index them while your team stays on the floor."
  },
  {
    "headline": "Make your Business Manager the control tower, not the bottleneck",
    "subtitle": "Centralise test drives, finance intros and finance approvals without adding another spreadsheet to the mix."
  },
  {
    "headline": "From back‑room boxes to a 10‑second search",
    "subtitle": "Move years of deal packs into the cloud and free your sales team from filing duty forever."
  },
  {
    "headline": "Close the deal, not just the paperwork",
    "subtitle": "Combine eSign, ePayments and eInvoice so every step from offer to handover lives in one workflow."
  },
  {
    "headline": "Say goodbye to wrong numbers and dead emails",
    "subtitle": "Verify mobiles and emails at capture, so every follow up, quote and payment link actually lands."
  },
  {
    "headline": "Be the manager who leaves on time",
    "subtitle": "Cut after hours scanning and file chasing with digital deal packs that are complete the first time."
  },
  {
    "headline": "One portal your customers actually understand",
    "subtitle": "Give buyers a simple place to view invoices, confirm bank details, pay and sign without printing a thing."
  },
  {
    "headline": "Protect your margins from invoice fraud with eInvoice",
    "subtitle": "Lock down bank details and cross check every invoice before it ever reaches your customer."
  },
  {
    "headline": "Sales, finance and service finally on the same page",
    "subtitle": "Link deals, ROs and invoices in one system so anyone can answer “what’s happening with this customer?” in seconds."
  },
  {
    "headline": "Turn your DMS into a deal closing machine",
    "subtitle": "Keep using your existing DMS and scanners while Drivible handles storage, search and digital approvals around it."
  },
  {
    "headline": "Never lose a commission to a lost deal pack",
    "subtitle": "Track every document, version and user action with a full audit trail on each sale."
  },
  {
    "headline": "The sales team’s shortcut to being “audit‑proof”",
    "subtitle": "Build compliant, searchable digital files as you go. No separate paper storage room, no extra headcount for sorting papers. No drama."
  },
  {
    "headline": "Scan it, slam it, deals that just happen",
    "subtitle": "One hit, bulk scan your day’s deals and let Drivible quietly do the heavy lifting while you close the next one."
  },
  {
    "headline": "Click, tick, contract done quick",
    "subtitle": "Fire off eSign links by SMS and email so customers commit while the smile is still on their face."
  },
  {
    "headline": "Tap, pay, drive away",
    "subtitle": "Roll deposits and card payments into one smooth portal so there’s no awkward money chat at delivery."
  },
  {
    "headline": "No more paper pain, just profit gain",
    "subtitle": "Turn back room boxes into a searchable goldmine of clean, audit‑ready sales files."
  },
  {
    "headline": "Deals, docs, done",
    "subtitle": "Keep every signature, statement and settlement in one place so no one ever asks “where’s that contract?” again."
  },
  {
    "headline": "From chaos to cashflow",
    "subtitle": "Tidy up your test drives, deal packs and payments so every admin step feeds your gross, not your stress."
  },
  {
    "headline": "Fast files, fatter front‑end",
    "subtitle": "Shave minutes off every deal pack and spend that time on better negotiations instead."
  },
  {
    "headline": "Sign, shine, and send them online",
    "subtitle": "Give customers a slick digital experience that feels more luxury lounge than dealer back office."
  },
  {
    "headline": "Scan, search, sell",
    "subtitle": "Drop today’s paperwork in once and pull it up in seconds from anywhere in the dealership."
  },
  {
    "headline": "Flirt less with fraud, more with finance",
    "subtitle": "Lock in trusted bank details and track every change with einvoices so car payments are exciting, not frightening."
  },
  {
    "headline": "Paperwork that behaves, deals that don’t cave",
    "subtitle": "Build bulletproof files around every sale so nothing falls over at audit or payout."
  },
  {
    "headline": "From filing room to freedom",
    "subtitle": "Shrink the paper mountain and give your sales team their evenings back without missing a single document."
  },
  {
    "headline": "Swipes, stripes, and smiling types",
    "subtitle": "Stripe powered payments and slick eSign flows that make you look like the most modern dealer in town."
  },
  {
    "headline": "Less scribble, more Drivible",
    "subtitle": "Swap illegible signatures and sticky notes for clean digital approvals everyone can read and trust."
  },
  {
    "headline": "Deals that stick, clicks that tick",
    "subtitle": "Every tap, sign and payment is tracked with a full audit log, so nothing gets lost in the shuffle."
  },
  {
    "headline": "Box room blues to boardroom bragging rights",
    "subtitle": "Show principals and OEMs a digital sales operation that runs tighter than their own reports."
  },
  {
    "headline": "Make your systems sexy again",
    "subtitle": "Keep the DMS and systems you know, but convert paper to digital, augment it with AI search and use online signing, payments and settlement pages that actually impress customers."
  }
];

const SERVICE_HEADLINES: RoleHeadlineItem[] = [
  { "headline": "Be the service manager who never stays back late", "subtitle": "Find every RO with AI‑empowered search, not a 7pm paper hunt." },
  { "headline": "Run your services without paperwork overwhelming your desk", "subtitle": "Bulk scan your ROs and easily store Invoices in Drivible so you can keep the service bays full, not your storage room." },
  { "headline": "Never be blindsided by an OEM audit again", "subtitle": "Turn scattered ROs, into a searchable archive that makes audits a 30‑minute task, not a 3‑day crisis." },
  { "headline": "Be the calm one when customers kick a fuss", "subtitle": "Pull up the full story on any RO or Loan Car in seconds so disputes become simple, fair conversations instead of finger pointing." },
  { "headline": "Turn “Have you seen that document?” into “It’s already in Drivible”", "subtitle": "Stop hunting through paper piles, inboxes, and shared drives just to answer a basic question." },
  { "headline": "Free a whole service advisor’s worth of time without hiring anyone", "subtitle": "Let AI split, label, and file today’s ROs while your team looks after customers instead of scanners." },
  { "headline": "Be the service manager who always has the answer", "subtitle": "When the DP, OEM, or a customer asks for proof, have the RO on screen in seconds. No need to call them back after 10 minutes of frantic searching in the backrooms." },
  { "headline": "Protect your team from blame with bulletproof Repair Orders", "subtitle": "Make sure every job has the same clear record, so mistakes in filing don’t turn into witch‑hunts." },
  { "headline": "Turn end‑of‑day chaos into “everything’s already done”", "subtitle": "Close the doors knowing you don't have to sort and file the documents, scan the ROs from the day and let our Bulk Document and Doc AI system do the heavy lifting." },
  { "headline": "Be the service advisor who never has to say “I’ll call you back”", "subtitle": "See the full RO while the customer is still on the phone." },
  { "headline": "Turn surprise audits into non‑events", "subtitle": "Export everything an auditor needs from one place instead of rebuilding jobs from five different systems." },
  { "headline": "Stop losing Saturdays to “just catching up on paperwork”", "subtitle": "Use one AI‑empowered archive so you can leave on time and still have audit‑ready service files." },
  { "headline": "For the people who really keep the Service department running", "subtitle": "Give your front‑of‑house team a system that matches the standard they already hold themselves to." },
  { "headline": "The service desk system that actually has your back", "subtitle": "Built for Australian workshops, not generic office workflows, so it survives real‑world chaos." },
  { "headline": "Keep technicians turning spanners, not chasing paperwork", "subtitle": "One simple flow for finished ROs. Bulk Document splitting means you don't have to sort and file, just scan at the end of the day and go home to your kids, or out to the pub with your mates." },
  { "headline": "Never lose a warranty claim to missing proof again", "subtitle": "Store every photo, signature, and RO in one place so you can respond to OEM questions in seconds." },
  { "headline": "Be the organised one without being the exhausted one", "subtitle": "Let Drivible quietly enforce good habits so your service lane runs smoothly without you playing traffic cop." },
  { "headline": "Service without the stress. Storage without the boxes", "subtitle": "Turn seven years of ROs, photos, and paperwork into a single source of truth that’s calm, controlled, and always at your fingertips." },
  { "headline": "Be the Service superhero, not the paperwork slave", "subtitle": "Save thousands of admin hours a year while your team focuses on customers, upsell, and getting cars out on time." },
  { "headline": "From Paper stuffed shelves to profit‑ready service", "subtitle": "Recover space, reclaim time, and run a tighter, more transparent workshop without adding headcount." },
  { "headline": "Calm, compliant, and completely under control", "subtitle": "Make audits, disputes, and OEM “he said, she said” moments simple by keeping every service record in one place." },
  { "headline": "From a paperwork jungle to just \"click and find\"", "subtitle": "Instead of stacked ROs out the back, have a searchable archive that surfaces the right file in seconds." },
  { "headline": "Turn mayhem into measurable margin", "subtitle": "Strip double entry, rework, and doc‑hunting out of your day so more time turns into billable hours." },
  { "headline": "Service that scales without the stress", "subtitle": "Add brands, bays, and bodies without multiplying paper rooms, or after‑hours admin." },
  { "headline": "From ring ring, phone call panic to “let me pull that up now”", "subtitle": "Give front of house the full documents from every service while the customer is still on the phone." },
  { "headline": "Bays busy, brains breathing", "subtitle": "Keep technicians turning spanners while Drivible handles the boring bits like documents, loan cars, invoice approvals, and audit trails." },
  { "headline": "Legendary service, invisible paperwork", "subtitle": "Deliver a five star experience at the counter while the compliance work happens quietly in the background." },
  { "headline": "Be the benchmark service department in your group", "subtitle": "Show your DP the numbers. Hours saved, audits passed, and comebacks avoided, without asking for another headcount." },
  { "headline": "From mystery files to masterpiece workflows", "subtitle": "Replace tribal knowledge and sticky notes with a repeatable, reliable process that new staff can follow on day one." },
  { "headline": "Turn late night paperwork into early knock off Fridays", "subtitle": "Close the day knowing tomorrow’s jobs, documents, and follow‑ups are already under control." },
  { "headline": "The quiet engine behind your CSI scores", "subtitle": "Keep customers informed, files complete, and disputes rare with one place for every service document." },
  { "headline": "Future proof your service department, not just your fleet", "subtitle": "Go from filing cabinets and containers to AI‑empowered archives that will still find what you need seven years from now." },
  { "headline": "From “where’s that Repair Order?” to “here it is”", "subtitle": "Stop tearing apart folders and binders. Pull up any critical document in a couple of seconds." },
  { "headline": "Make your workshop feel wonderfully, weirdly quiet", "subtitle": "Not fewer bookings, just fewer panicked interruptions, lost documents, and last minute scrambles before audits." }
];
const FINANCE_HEADLINES: RoleHeadlineItem[] = [
  { "headline": "Be the F&I manager who never loses a contract again", "subtitle": "Every signed form, approval, and payout lives in one audit ready digital archive instead of scattered across desks, inboxes, and filing cabinets." },
  { "headline": "Turn Finance approvals from a bottleneck into a profit lever", "subtitle": "Remove the paper chasing your team can spend their time structuring better deals, not hunting for missing payment approvals." },
  { "headline": "Know exactly who approved what, and when", "subtitle": "Every contract and payment event carries a timestamped audit trail so compliance reviews become routine, not stressful." },
  { "headline": "Protect your Deal margins from fat‑fingered bank details", "subtitle": "eInvoices cross‑check settlement accounts before anything goes out, catching tampered details before users pay the wrong account." },
  { "headline": "Be ready for your next audit before it’s even announced", "subtitle": "Stamp and Bulk Document Scan a complete, searchable set of Account Invoices, so OEMs and regulators see a clean story without you pulling late nights." },
  { "headline": "Give compliance everything they want without sacrificing speed", "subtitle": "Versioned terms, eSign, and audit logs run quietly in the background while your F&I team keeps saying “yes” to good deals." },
  { "headline": "“Can you send me that invoice?” is now a 10 second job not 10 minutes", "subtitle": "Full text search across every RO, deal, and account invoice means Finance can respond on the spot, even with an auditor in the room." },
  { "headline": "Stop paying for storage rooms that don’t sell cars", "subtitle": "Move documents into the cloud, reclaim floor space, and still keep the required seven years of history at your fingertips." },
  { "headline": "Catch fraud attempts before your customer does", "subtitle": "Verified bank details, alerts on changes, and a secure portal reduce invoice fraud risk before it hits your balance sheet." },
  { "headline": "Better Finance paperwork, without hiring another administrator", "subtitle": "Automate the boring work of approvals and filing so your current team can focus on conversations that actually move the needle." },
  { "headline": "Turn every finance deal into an audit proof story", "subtitle": "From first approval to final payment, Drivible keeps the evidence trail complete, readable, and ready to share." },
  { "headline": "Give your accountants clean data instead of cold‑case files", "subtitle": "Structured documents, consistent naming, and integrated payments mean less time decoding paperwork and more time analysing profit." },
  { "headline": "Be the Finance team that always knows the answer", "subtitle": "One search bar across contracts, payouts, and ROs means you can say “Here it is” instead of “Give me a few minutes”." },
  { "headline": "Let AI handle the filing so Finance can handle the money", "subtitle": "Bulk scan, auto‑split, and OCR do the grunt work, freeing your finance staff to focus on risk, margin, and customer outcomes." }
];

export const ROLE_HEADLINES: Record<RoleKey, RoleHeadlineItem[]> = {
  management: MANAGEMENT_HEADLINES,
  sales: SALES_HEADLINES,
  service: SERVICE_HEADLINES,
  finance: FINANCE_HEADLINES,
};
